import React, { useMemo } from "react";
import { IconButton, Typography, makeStyles } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { IconAddCircle, IconDeleteCircle } from "@/components/Icon";

const useStyles = makeStyles(theme => ({
  block: {
    marginBottom: theme.spacing(2)
  },
  title: {
    marginBottom: theme.spacing(1)
  },
  item: {
    display: "flex",
    alignItems: "center",
    marginLeft: -12
  }
}));

const Option = ({ shown, hidden, widgetIndex, title, onChange }) => {
  const classes = useStyles();

  return (
    <div className={classes.item}>
      <IconButton onClick={e => onChange(e, widgetIndex, !shown)}>
        {hidden && <IconAddCircle size={17} />}
        {shown && <IconDeleteCircle size={17} />}
      </IconButton>
      <Typography variant="body2">{title}</Typography>
    </div>
  );
};

const OptionList = props => {
  const { title, list, shown, hidden, onChange } = props;
  const classes = useStyles();

  return (
    <>
      <Typography variant="body2">{title}</Typography>
      <div className={classes.block}>
        {list.map((item, index) => {
          return (
            <Option
              key={item.title}
              shown={shown}
              hidden={hidden}
              title={item.title}
              widgetIndex={item.widgetIndex}
              onChange={onChange}
            />
          );
        })}
      </div>
    </>
  );
};

const Index = React.memo(({ value, onChange }) => {
  const { t } = useTranslation();

  const groups = useMemo(() => {
    const groups = {
      visible: {
        title: t({ defaultMessage: "显示" }),
        list: []
      },
      invisible: {
        title: t({ defaultMessage: "隐藏" }),
        list: []
      }
    };
    value.forEach(item => {
      if (item.visible) {
        groups.visible.list.push(item);
      } else {
        groups.invisible.list.push(item);
      }
    });

    return groups;
  }, [value]);

  const handleChange = (e, widgetIndex, shown) => {
    onChange(
      value.map((item, i) => {
        if (item.widgetIndex === widgetIndex) {
          return {
            ...item,
            visible: shown
          };
        }
        return item;
      })
    );
  };

  return (
    <>
      <OptionList
        title={groups.visible.title}
        list={groups.visible.list}
        shown
        onChange={handleChange}
      />
      <OptionList
        title={groups.invisible.title}
        list={groups.invisible.list}
        hidden
        onChange={handleChange}
      />
    </>
  );
});

export default Index;
